
// grupos sincronizados com o AD
// seguir o padrão de nomenclatura: gbi_projetos_simplifica_<perfil>
// exemplo:
// gbi_projetos_simplifica_admin - grupo de administradores do sistema
const ADMIN = "gbi_projetos-simplifica_admin";
const SERVIDOR = "SERVIDOR";
const LOGADO = "LOGADO";
const AUDITOR = "AUDITOR";
const GERENTE = "gbi_projetos-simplifica_gerente";
const HOMOLOG = "gbi_projetos-simplifica_homolog";
const COMPRAS = "gbi_projetos-simplifica_compras-proadi";
const COMPRAS_TIC = "gbi_projetos-simplifica_compras-agetic";


export default { ADMIN, SERVIDOR, LOGADO, AUDITOR, GERENTE, HOMOLOG, COMPRAS, COMPRAS_TIC};
